var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "testimonials testimonials--carousel container text-center",
      style: _vm.paddingStyles
    },
    [
      _c(
        "h3",
        {
          staticClass: "h3 testimonials__title text-center",
          class: _vm.schema.settings.sectionHeaderColor
        },
        [_vm._v(_vm._s(_vm.schema.settings.sectionHeader))]
      ),
      _c(
        "swiper",
        {
          ref: "swiper",
          staticClass: "testimonials__testimonials",
          attrs: { id: "testimonial-slider", options: _vm.swiperOptions }
        },
        _vm._l(_vm.schema.blocks, function(block) {
          return _c("swiper-slide", { key: block.id }, [
            _c("article", { staticClass: "testimonials__testimonial" }, [
              _c("div", { staticClass: "testimonials__inner" }, [
                block.settings.testimonial_source
                  ? _c(
                      "p",
                      {
                        staticClass: "h7 testimonials__source",
                        class: _vm.schema.settings.textColor
                      },
                      [_vm._v(_vm._s(block.settings.testimonial_source))]
                    )
                  : _c("img", {
                      attrs: {
                        src: _vm.schema.settings.defaultQuoteImg,
                        alt: "quotation mark",
                        "aria-role": "presentation"
                      }
                    }),
                _c("blockquote", {
                  staticClass: "body-sm testimonials__body",
                  class: _vm.schema.settings.textColor,
                  domProps: {
                    innerHTML: _vm._s(block.settings.testimonial_body)
                  }
                }),
                block.settings.testimonial_logo
                  ? _c("img", {
                      staticClass: "testimonials__img",
                      attrs: {
                        "aria-role": "presentation",
                        src: _vm.imageSize(
                          block.settings.testimonial_logo,
                          "256x256"
                        ),
                        srcset:
                          _vm.imageSize(
                            block.settings.testimonial_logo,
                            "128x128"
                          ) +
                          " 1x, " +
                          _vm.imageSize(
                            block.settings.testimonial_logo,
                            "256x256"
                          ) +
                          " 2x",
                        alt: block.testimonial_logo_alt
                      }
                    })
                  : _vm._e()
              ])
            ])
          ])
        }),
        1
      ),
      _c("div", { staticClass: "testimonials__pagination" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }